const STORAGE_KEY = 'ga4ItemCategories';
const MAX_ENTRIES = 50;

type CategoryMap = Record<string, string>;

const readMap = (): CategoryMap => {
  if (typeof window === 'undefined') return {};

  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};

    const parsed: unknown = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};

    return Object.entries(parsed).reduce<CategoryMap>((map, [productId, category]) => {
      if (typeof category === 'string' && category.trim()) {
        map[productId] = category;
      }
      return map;
    }, {});
  } catch {
    return {};
  }
};

export const rememberGa4ItemCategory = (productId: string | number, itemCategory: string) => {
  const category = itemCategory.trim();
  if (!category || productId === undefined || productId === null || productId === '') return;
  if (typeof window === 'undefined') return;

  try {
    const map = readMap();
    const key = String(productId);
    delete map[key];
    map[key] = category;

    const keys = Object.keys(map);
    if (keys.length > MAX_ENTRIES) {
      keys.slice(0, keys.length - MAX_ENTRIES).forEach((oldKey) => {
        delete map[oldKey];
      });
    }

    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // sessionStorage unavailable
  }
};

export const getRememberedGa4ItemCategory = (productId: string | number): string => {
  if (productId === undefined || productId === null || productId === '') return '';

  return readMap()[String(productId)] ?? '';
};
